import hrmsLovCodcompLabels from 'assets/labels/hrmsLov'

export const mocker = {
  lovCodcompLabels () {
    return {
      labels: hrmsLovCodcompLabels
    }
  },
  lovCodcomp () {
    let mockRows = [{
      codcomp: 'TJS000000000000000000',
      v_codcomp: 'TJS',
      comlevel: 1,
      desc_codcomp: 'TJS000000000000000000'
    }, {
      codcomp: 'TJS001000000000000000',
      v_codcomp: 'TJS001',
      comlevel: 2,
      desc_codcomp: 'TJS001000000000000000'
    }, {
      codcomp: 'TJS002000000000000000',
      v_codcomp: 'TJS002',
      comlevel: 2,
      desc_codcomp: 'TJS002000000000000000'
    }, {
      codcomp: 'TJS001002000000000000',
      v_codcomp: 'TJS001002',
      comlevel: 3,
      desc_codcomp: 'TJS001002000000000000'
    }, {
      codcomp: 'TJS001002003000000000',
      v_codcomp: 'TJS001002003',
      comlevel: 4,
      desc_codcomp: 'TJS001002003000000000'
    }, {
      codcomp: 'TJS001002003004000000',
      v_codcomp: 'TJS001002003004',
      comlevel: 5,
      desc_codcomp: 'TJS001002003004000000'
    }, {
      codcomp: 'TJS001002003004005000',
      v_codcomp: 'TJS001002003004005',
      comlevel: 6,
      desc_codcomp: 'TJS001002003004005000'
    }, {
      codcomp: 'TJS001002003004005006',
      v_codcomp: 'TJS001002003004005006',
      comlevel: 7,
      desc_codcomp: 'TJS001002003004005006'
    }, {
      codcomp: 'PPS000000000000000000',
      v_codcomp: 'PPS',
      comlevel: 1,
      desc_codcomp: 'PPS000000000000000000'
    }, {
      codcomp: 'PPS001000000000000000',
      v_codcomp: 'PPS001',
      comlevel: 2,
      desc_codcomp: 'PPS001000000000000000'
    }, {
      codcomp: 'PPS001002000000000000',
      v_codcomp: 'PPS001002',
      comlevel: 3,
      desc_codcomp: 'PPS001002000000000000'
    }, {
      codcomp: 'PPS001002003000000000',
      v_codcomp: 'PPS001002003',
      comlevel: 4,
      desc_codcomp: 'PPS001002003000000000'
    }, {
      codcomp: 'PPS001002003004000000',
      v_codcomp: 'PPS001002003004',
      comlevel: 5,
      desc_codcomp: 'PPS001002003004000000'
    }, {
      codcomp: 'PPS001002003004005000',
      v_codcomp: 'PPS001002003004005',
      comlevel: 6,
      desc_codcomp: 'PPS001002003004005000'
    }, {
      codcomp: 'PPS001002003004005006',
      v_codcomp: 'PPS001002003004005006',
      comlevel: 7,
      desc_codcomp: 'PPS001002003004005006'
    }, {
      codcomp: 'AJT000000000000000000',
      v_codcomp: 'AJT',
      comlevel: 1,
      desc_codcomp: 'AJT000000000000000000'
    }, {
      codcomp: 'AJT001000000000000000',
      v_codcomp: 'AJT001',
      comlevel: 2,
      desc_codcomp: 'AJT001000000000000000'
    }, {
      codcomp: 'AJT001002000000000000',
      v_codcomp: 'AJT001002',
      comlevel: 3,
      desc_codcomp: 'AJT001002000000000000'
    }, {
      codcomp: 'AJT001002003000000000',
      v_codcomp: 'AJT001002003',
      comlevel: 4,
      desc_codcomp: 'AJT001002003000000000'
    }, {
      codcomp: 'AJT001002003004000000',
      v_codcomp: 'AJT001002003004',
      comlevel: 5,
      desc_codcomp: 'AJT001002003004000000'
    }, {
      codcomp: 'AJT001002003004005000',
      v_codcomp: 'AJT001002003004005',
      comlevel: 6,
      desc_codcomp: 'AJT001002003004005000'
    }, {
      codcomp: 'AJT001002003004005006',
      v_codcomp: 'AJT001002003004005006',
      comlevel: 7,
      desc_codcomp: 'AJT001002003004005006'
    }, {
      codcomp: 'BKG000000000000000000',
      v_codcomp: 'BKG',
      comlevel: 1,
      desc_codcomp: 'BKG000000000000000000'
    }, {
      codcomp: 'BKG001000000000000000',
      v_codcomp: 'BKG001',
      comlevel: 2,
      desc_codcomp: 'BKG001000000000000000'
    }, {
      codcomp: 'BKG001002000000000000',
      v_codcomp: 'BKG001002',
      comlevel: 3,
      desc_codcomp: 'BKG001002000000000000'
    }, {
      codcomp: 'BKG001002003000000000',
      v_codcomp: 'BKG001002003',
      comlevel: 4,
      desc_codcomp: 'BKG001002003000000000'
    }, {
      codcomp: 'BKG001002003004000000',
      v_codcomp: 'BKG001002003004',
      comlevel: 5,
      desc_codcomp: 'BKG001002003004000000'
    }, {
      codcomp: 'BKG001002003004005000',
      v_codcomp: 'BKG001002003004005',
      comlevel: 6,
      desc_codcomp: 'BKG001002003004005000'
    }, {
      codcomp: 'BKG001002003004005006',
      v_codcomp: 'BKG001002003004005006',
      comlevel: 7,
      desc_codcomp: 'BKG001002003004005006'
    }]
    return {
      total: mockRows.length,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsLovCodcomp/mocker.js